<template>
    <div class="all-tickets-stack__table-header">
        <div class="table-col__first">
            #
        </div>
        <div class="table-col__quote">
            {{ $t('quote') | upperCase }}
        </div>
        <div class="table-col__stake">
            {{ $t('stake') | upperCase }}
        </div>
        <div class="table-col__potential-win">
            {{ $t(winText) | upperCase }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TicketTableHeader',
        props: {
            isWon: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        computed: {
            winText() {
                return this.isWon ? 'payout' : 'potential win';
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/TicketTableHeader.vue